import {
  // DeFi/Web3
  argentWallet,
  backpackWallet,
  bifrostWallet,
  // Exchange Wallets
  binanceWallet,
  bitgetWallet,
  // Additional Wallets
  bitskiWallet,
  bitverseWallet,
  bloomWallet,
  braveWallet,
  bybitWallet,
  coinbaseWallet,
  coreWallet,
  dawnWallet,
  foxWallet,
  frameWallet,
  frontierWallet,
  gateWallet,
  imTokenWallet,
  // Generic/Essential
  injectedWallet,
  kaiaWallet,
  kaikasWallet,
  krakenWallet,
  kresusWallet,
  ledgerWallet,
  magicEdenWallet,
  // Major Wallets
  metaMaskWallet,
  mewWallet,
  okxWallet,
  omniWallet,
  oneInchWallet,
  oneKeyWallet,
  paraSwapWallet,
  phantomWallet,
  rabbyWallet,
  rainbowWallet,
  ramperWallet,
  roninWallet,
  safeheronWallet,
  safeWallet,
  tahoWallet,
  talismanWallet,
  tokenaryWallet,
  tokenPocketWallet,
  trustWallet,
  uniswapWallet,
  valoraWallet,
  walletConnectWallet,
  wigwamWallet,
  xdefiWallet,
  zerionWallet,
} from "@rainbow-me/rainbowkit/wallets";

// Enable Coinbase Smart Wallet for testing
coinbaseWallet.preference = "smartWalletOnly";

export const walletList = [
  {
    groupName: "Recommended",
    wallets: [coinbaseWallet, injectedWallet, metaMaskWallet, walletConnectWallet],
  },
  {
    groupName: "Banking & Finance",
    wallets: [
      binanceWallet,
      bitgetWallet,
      bybitWallet,
      krakenWallet,
      ledgerWallet,
      okxWallet,
      safeheronWallet,
      safeWallet,
      trustWallet,
    ],
  },
  {
    groupName: "Web3 Native",
    wallets: [
      argentWallet,
      braveWallet,
      frameWallet,
      omniWallet,
      oneInchWallet,
      paraSwapWallet,
      rabbyWallet,
      talismanWallet,
      uniswapWallet,
      zerionWallet,
    ],
  },
  {
    groupName: "Gaming & NFTs",
    wallets: [backpackWallet, kaikasWallet, magicEdenWallet, phantomWallet, rainbowWallet, roninWallet],
  },
  {
    groupName: "Additional Options",
    wallets: [
      bifrostWallet,
      bitskiWallet,
      bitverseWallet,
      bloomWallet,
      coreWallet,
      dawnWallet,
      foxWallet,
      frontierWallet,
      gateWallet,
      imTokenWallet,
      kaiaWallet,
      kresusWallet,
      mewWallet,
      oneKeyWallet,
      ramperWallet,
      tahoWallet,
      tokenaryWallet,
      tokenPocketWallet,
      valoraWallet,
      wigwamWallet,
      xdefiWallet,
    ],
  },
];
